/* Marobali – moteur d'aperçu 3D des pièces (atelier + fiches produit).
   Formes relevées sur les pièces vendues, motifs peints dans une texture,
   rendu three.js (r147, chargé à la demande depuis jsDelivr). */
(function () {
  if (window.MarobaliAtelier) return;

  var CDN = 'https://cdn.jsdelivr.net/npm/three@0.147.0/';
  var loading = null;
  function loadScript(src) {
    return new Promise(function (res, rej) {
      var e = document.createElement('script');
      e.src = src; e.async = true; e.onload = res; e.onerror = function () { rej(new Error('load ' + src)); };
      document.head.appendChild(e);
    });
  }
  function loadThree() {
    if (window.THREE && THREE.OrbitControls && THREE.RoomEnvironment) return Promise.resolve();
    if (loading) return loading;
    loading = (window.THREE ? Promise.resolve() : loadScript(CDN + 'build/three.min.js')).then(function () {
      return Promise.all([
        THREE.OrbitControls ? 0 : loadScript(CDN + 'examples/js/controls/OrbitControls.js'),
        THREE.RoomEnvironment ? 0 : loadScript(CDN + 'examples/js/environments/RoomEnvironment.js')
      ]);
    });
    return loading;
  }

  /* ---------- Nuancier ---------- */
  var PALETTE = [
    ['Rouge', '#a3191a'], ['Prune', '#5b2a35'], ['Lilas', '#b9a6c0'], ['Rose', '#d98291'], ['Rose clair', '#e6b3bd'], ['Rose poudré', '#dfb8aa'],
    ['Jaune', '#e3c20b'], ['Safran', '#d9990a'], ['Terracotta', '#d9733a'], ['Caramel', '#b5600c'], ['Chocolat', '#35170e'],
    ['Vert pomme', '#86a04c'], ['Vert olive', '#3d4d16'], ['Vert bouteille', '#3c4a22'], ['Vert émeraude', '#2e5b49'], ['Vert sapin', '#1d3b33'], ['Céladon', '#9fc0bd'],
    ['Bleu ciel', '#4b86bd'], ['Bleu pétrole', '#213e48'], ['Bleu nuit', '#1b1f5e'], ['Gris', '#86858d'], ['Noir', '#1f1b16'], ['Blanc', '#ece6e2']
  ];
  var NATURAL = 'Blanc naturel', NATURAL_HEX = '#f4efe7';
  var CLAYS = {
    blanche: { label: 'Terre blanche', raw: '#e6dac7', grainA: '#d8cab3', grainB: '#efe6d6' },
    rouge: { label: 'Terre rouge', raw: '#b9683f', grainA: '#a3552f', grainB: '#cd8458' }
  };
  function hexOf(name) {
    if (!name || name === NATURAL) return NATURAL_HEX;
    for (var i = 0; i < PALETTE.length; i++) if (PALETTE[i][0] === name) return PALETTE[i][1];
    return NATURAL_HEX;
  }

  /* ---------- Formes (cm) : profil extérieur du pied jusqu'au bord ---------- */
  function plateKeys(R) {
    var k = R / 13.5, h = 0.72 + 0.28 * k;
    var base = [[0, .5], [7.3, .5], [8.5, .72], [10, 1.25], [12, 1.95], [13.2, 2.3], [13.5, 2.26], [13.55, 2.08], [13.3, 1.9], [11.8, 1.5], [9.6, .92], [8, .5], [7.1, .38], [6.9, .06], [6.75, 0], [6.15, 0], [5.95, .2], [0, .2]];
    return base.map(function (p) { return [p[0] * k, p[1] * h]; });
  }
  var SHAPES = {
    'pichet': { label: 'Pichet', dims: 'Ø9,5 × H21 cm', group: 'Tasses & pichets', kind: 'vessel', t: .5, floor: .85,
      outer: [[0, .3], [6.4, .3], [6.75, 0], [7.0, .06], [7.08, .45], [5.75, 10.7], [4.45, 20.75], [4.4, 21]],
      handle: { type: 'strap', pts: [[4.2, 20.3], [6.1, 20.75], [7.6, 20.45], [8.3, 19.3], [8.42, 17.4], [8.15, 14.5], [7.65, 11.5], [7.05, 9.0], [6.55, 7.2], [6.1, 6.4]], r: .8, sx: 1.15 },
      spout: { amp: .6, width: .3, from: 19.3, lift: .22 }, stripes: { n: 8, w: 2.45, ang: 7.0 }, bands: { h: 1.25, gap: 1.25 } },
    'mug': { label: 'Mug', dims: 'Ø9 × H11 cm', group: 'Tasses & pichets', kind: 'vessel', t: .42, floor: .8,
      outer: [[0, .25], [3.6, .25], [3.85, 0], [4.25, 0], [4.45, .25], [4.5, 1], [4.5, 10.5], [4.47, 11]],
      handle: { type: 'ring', cy: 5.9, cr: 2.05, off: 1.55, r: .42, sx: 1.25 }, stripes: { n: 12, w: .95 }, bands: { h: 1, gap: 1 } },
    'tasse-cafe': { label: 'Tasse à café', dims: 'Ø7 × H7 cm', group: 'Tasses & pichets', kind: 'vessel', t: .35, floor: .7,
      outer: [[0, .2], [2.7, .2], [2.9, 0], [3.25, 0], [3.45, .2], [3.5, .8], [3.5, 6.6], [3.47, 7]],
      handle: { type: 'ring', cy: 3.7, cr: 1.35, off: 1.0, r: .3, sx: 1.2 }, stripes: { n: 10, w: .8 }, bands: { h: .55, gap: .55 }, hDefault: true },
    'bol': { label: 'Bol', dims: 'Ø14,5 × H6,5 cm', group: 'Bols & saladiers', kind: 'open', t: .42, floor: .85,
      outer: [[0, .25], [2.9, .25], [3.1, 0], [3.6, 0], [3.85, .4], [4.5, .9], [5.6, 1.6], [6.5, 2.7], [7.0, 4.0], [7.2, 5.3], [7.25, 6.5]],
      stripes: { n: 16, w: 1.05 }, bands: { h: .9, gap: .9 } },
    /* bol à pied de la collection terre cuite (uni, terre rouge) */
    'bol-pied': { label: 'Bol', dims: 'Ø15 × H8 cm', group: 'Bols & saladiers', kind: 'open', t: .42, floor: 2.1, hidden: true,
      outer: [[0, .25], [2.95, .25], [3.15, 0], [3.5, 0], [3.6, .3], [3.42, .8], [3.02, 1.25], [2.95, 1.6], [3.2, 1.9], [4.3, 2.85], [5.3, 3.95], [6.15, 5.15], [6.82, 6.4], [7.28, 7.55], [7.5, 8.2]],
      stripes: { n: 16, w: 1.1 }, bands: { h: .9, gap: .9 } },
    'saladier': { label: 'Saladier', dims: 'Ø23 × H9 cm', group: 'Bols & saladiers', kind: 'open', t: .55, floor: 1.0,
      outer: [[0, .3], [4.0, .3], [4.2, 0], [4.9, 0], [5.2, .5], [5.6, .9], [7.5, 2.6], [9.5, 5.0], [10.9, 7.4], [11.5, 9]],
      stripes: { n: 22, w: 1.15 }, bands: { h: 1.1, gap: 1.1 } },
    'saladier-trapeze': { label: 'Saladier trapèze', dims: 'Ø20 × H12,5 cm', group: 'Bols & saladiers', kind: 'open', t: .65, floor: 1.0,
      outer: [[0, .3], [8.4, .3], [8.7, 0], [9.6, 0], [9.95, .4], [10, 1.2], [9.6, 6], [9.15, 11], [9.05, 12.2], [9.0, 12.5]],
      stripes: { n: 22, w: 1.2 }, bands: { h: 1.15, gap: 1.15 } },
    'assiette-creuse-arrondie': { label: 'Assiette creuse arrondie', dims: 'Ø17 cm', group: 'Assiettes', kind: 'open', t: .45, floor: .75,
      outer: [[0, .25], [5.0, .25], [5.25, 0], [5.9, 0], [6.6, .3], [7.4, .9], [8.1, 1.9], [8.45, 3.0], [8.5, 4.2], [8.45, 4.6]],
      stripes: { n: 20, w: 1.0 }, bands: { h: .8, gap: .8 } },
    'assiette-creuse': { label: 'Assiette creuse', dims: 'Ø21 cm', group: 'Assiettes', kind: 'open', t: .5, floor: .75,
      outer: [[0, .25], [7.6, .25], [7.85, 0], [8.6, 0], [9.1, .3], [9.6, .9], [10.1, 2.0], [10.4, 3.2], [10.5, 3.8]],
      stripes: { n: 22, w: 1.05 }, bands: { h: .8, gap: .8 } },
    'assiette-petite': { label: 'Assiette petite', dims: 'Ø18 cm', group: 'Assiettes', kind: 'plate', R: 9, stripes: { n: 20, w: .9 }, bands: { h: .9, gap: .9 } },
    'assiette-moyenne': { label: 'Assiette moyenne', dims: 'Ø24 cm', group: 'Assiettes', kind: 'plate', R: 12, stripes: { n: 24, w: 1.0 }, bands: { h: 1.1, gap: 1.1 } },
    'assiette-grande': { label: 'Assiette grande', dims: 'Ø27 cm', group: 'Assiettes', kind: 'plate', R: 13.5, stripes: { n: 26, w: 1.05 }, bands: { h: 1.2, gap: 1.2 } },
    'pot-ustensiles': { label: 'Pot à ustensiles', dims: 'Ø12,5 × H18 cm', group: 'Déco', kind: 'vessel', t: .5, floor: .9,
      outer: [[0, .25], [5.3, .25], [5.55, 0], [6.0, 0], [6.22, .25], [6.25, 1], [6.18, 9], [6.25, 17.4], [6.22, 18]],
      stripes: { n: 14, w: 1.25 }, bands: { h: 1.3, gap: 1.3 } },
    'cache-pot-petit': { label: 'Cache-pot petit', dims: 'Ø14 × H15 cm', group: 'Déco', kind: 'vessel', t: .55, floor: .9,
      outer: [[0, .25], [6.0, .25], [6.25, 0], [6.75, 0], [6.97, .25], [7, 1], [7, 14.5], [6.96, 15]],
      stripes: { n: 16, w: 1.25 }, bands: { h: 1.3, gap: 1.3 } },
    'cache-pot-grand': { label: 'Cache-pot grand', dims: 'Ø18 × H19 cm', group: 'Déco', kind: 'vessel', t: .6, floor: 1.0,
      outer: [[0, .3], [7.8, .3], [8.05, 0], [8.7, 0], [8.97, .3], [9, 1.2], [9, 18.5], [8.96, 19]],
      stripes: { n: 20, w: 1.35 }, bands: { h: 1.4, gap: 1.4 } },
    /* cendriers marocains : corps bombé + couvercle-collerette posé dessus, entonnoir et téton au fond ; en terre rouge uniquement */
    'cendrier-petit': { label: 'Cendrier petit', dims: 'Ø12 × H9 cm', group: 'Déco', kind: 'vessel', t: .45, floor: 1.0, neckY: 7.35,
      outer: [[0, .2], [3.2, .2], [3.4, 0], [4.0, 0], [4.2, .3], [4.3, .7], [5.2, 1.4], [5.85, 2.6], [6.0, 3.8], [5.8, 5.0], [5.1, 6.1], [4.2, 6.9], [3.6, 7.3], [3.55, 7.5]],
      lid: [[4.0, 7.55], [4.3, 7.8], [4.4, 8.2], [4.25, 8.55], [3.95, 8.75], [3.2, 8.7], [2.6, 8.55], [2.25, 8.3], [2.1, 7.8], [2.05, 2.0], [1.85, 1.3], [1.2, 1.25], [.9, 1.5], [.6, 2.1], [0, 2.5]], lidBand: 1.5, clays: ['rouge'],
      stripes: { n: 12, w: 1.25 }, bands: { h: .7, gap: .7 }, viewPolar: .95 },
    'cendrier-grand': { label: 'Cendrier grand', dims: 'Ø20 × H11 cm', group: 'Déco', kind: 'vessel', t: .55, floor: 1.1, neckY: 9.3,
      outer: [[0, .2], [5.4, .2], [5.6, 0], [6.6, 0], [7.0, .35], [8.6, 1.2], [9.7, 2.6], [10, 4.0], [9.7, 5.6], [8.7, 7.0], [7.2, 8.2], [5.9, 8.9], [5.3, 9.25], [5.35, 9.45]],
      lid: [[5.9, 9.5], [6.2, 9.75], [6.3, 10.15], [6.1, 10.5], [5.7, 10.75], [4.6, 10.7], [3.6, 10.55], [3.15, 10.3], [2.95, 9.8], [2.9, 8.5], [2.85, 2.0], [2.6, 1.4], [1.6, 1.3], [1.2, 1.6], [.8, 2.4], [0, 2.9]], lidBand: 1.9, clays: ['rouge'],
      stripes: { n: 16, w: 1.6 }, bands: { h: .85, gap: .85 }, viewPolar: .95 }
  };
  Object.keys(SHAPES).forEach(function (k) { if (SHAPES[k].kind === 'plate') SHAPES[k].keys = plateKeys(SHAPES[k].R); });

  var MOTIFS = [
    { id: 'rayuresV', label: 'Rayures verticales' },
    { id: 'rayuresH', label: 'Rayures horizontales' },
    { id: 'cercles', label: 'Cercles' },
    { id: 'taches', label: 'Taches' },
    { id: 'uni', label: 'Uni' }
  ];

  /* Motifs proposés dans l'atelier selon la pièce :
     cercles = assiettes et saladiers ; rayures horizontales = tout sauf les assiettes */
  function motifsFor(key) {
    var def = SHAPES[key]; if (!def) return [];
    var plate = def.group === 'Assiettes', salad = key.indexOf('saladier') === 0;
    return MOTIFS.filter(function (m) {
      if (m.id === 'cercles') return plate || salad;
      if (m.id === 'rayuresH') return !plate;
      return true;
    }).map(function (m) { return { id: m.id, label: plate && m.id === 'rayuresV' ? 'Rayures' : m.label }; });
  }

  /* Fiche produit → forme + motif (null pour le motif « dessins ») */
  function fromProduct(title, type) {
    var t = (title || '').toLowerCase(), shape = null, motif = null;
    if (t.indexOf('dessin') >= 0 || t.indexOf('coupe') >= 0) return null;
    if (t.indexOf('pichet') >= 0) shape = 'pichet';
    else if (t.indexOf('pot') >= 0 && t.indexOf('ustensile') >= 0) shape = 'pot-ustensiles';
    else if (t.indexOf('cache-pot') >= 0) shape = t.indexOf('grand') >= 0 ? 'cache-pot-grand' : 'cache-pot-petit';
    else if (t.indexOf('cendrier') >= 0) shape = t.indexOf('grand') >= 0 ? 'cendrier-grand' : 'cendrier-petit';
    else if (t.indexOf('mug') >= 0) shape = 'mug';
    else if (t.indexOf('tasse') >= 0) shape = 'tasse-cafe';
    else if (t.indexOf('saladier') >= 0) shape = t.indexOf('trap') >= 0 ? 'saladier-trapeze' : 'saladier';
    else if (t.indexOf('bol') >= 0) shape = 'bol';
    else if (t.indexOf('assiette creuse') >= 0) shape = t.indexOf('arrondie') >= 0 ? 'assiette-creuse-arrondie' : 'assiette-creuse';
    else if (t.indexOf('assiette') >= 0) shape = t.indexOf('petite') >= 0 ? 'assiette-petite' : (t.indexOf('moyenne') >= 0 ? 'assiette-moyenne' : 'assiette-grande');
    if (!shape) return null;
    if (t.indexOf('cercle') >= 0) motif = shape.indexOf('cendrier') === 0 ? 'rayuresH' : 'cercles';
    else if (t.indexOf('tache') >= 0) motif = 'taches';
    else if (t.indexOf('rayure') >= 0 || t.indexOf('bande') >= 0) motif = shape === 'tasse-cafe' ? 'rayuresH' : 'rayuresV';
    if (!motif) return null;
    return { shape: shape, motif: motif };
  }

  /* uni en terre rouge : pièce trempée dans l'émail, terre cuite apparente ; le bol devient le bol à pied */
  function isDip(d) { return d.clay === 'rouge' && d.motif === 'uni'; }
  /* trempage visible : segment sur les assiettes, croissant sur les autres pièces ; tasses, mugs et pichets gardent l'intérieur en terre cuite vernie */
  function dipMode(d) { var s = SHAPES[shapeKeyFor(d)] || SHAPES[d.shape]; if (!isDip(d) || !s) return ''; return s.kind === 'plate' || s.group === 'Assiettes' ? 'chord' : (s.group === 'Tasses & pichets' ? '' : 'band'); }
  /* argiles possibles pour une forme (les cendriers n'existent qu'en terre rouge) */
  function claysFor(key) { var s = SHAPES[key]; return s && s.clays ? s.clays.slice() : Object.keys(CLAYS); }
  function shapeKeyFor(d) { return d.shape === 'bol' && isDip(d) ? 'bol-pied' : d.shape; }

  /* ---------- Outils ---------- */
  function rng(seed) { return function () { seed |= 0; seed = seed + 0x6D2B79F5 | 0; var t = Math.imul(seed ^ seed >>> 15, 1 | seed); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  function noise1(seed) { var r = rng(seed), v = []; for (var i = 0; i < 512; i++) v.push(r()); return function (x) { var i = Math.floor(x), f = x - i, t = f * f * (3 - 2 * f); var a = v[((i % 512) + 512) % 512], b = v[(((i + 1) % 512) + 512) % 512]; return a + (b - a) * t; }; }
  function smooth(a, b, x) { var t = Math.min(1, Math.max(0, (x - a) / (b - a))); return t * t * (3 - 2 * t); }
  function shade(hex, amt) { var n = parseInt(hex.slice(1), 16), r = n >> 16, g = n >> 8 & 255, b = n & 255, T = amt > 0 ? 255 : 0, a = Math.abs(amt); r = Math.round(r + (T - r) * a); g = Math.round(g + (T - g) * a); b = Math.round(b + (T - b) * a); return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1); }
  var VIV = Object.assign({ s: 1.3, l: 0, fs: 1.2, fl: 0, exp: 1.0, tm: 'none' }, window.MB_VIVID || {});
  /* émail cuit : un peu plus vif et lumineux que le nuancier à l'écran */
  function vivid(hex, sat, lift) {
    var n = parseInt(hex.slice(1), 16), r = (n >> 16) / 255, g = (n >> 8 & 255) / 255, b = (n & 255) / 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2, h = 0, sa = 0, d = mx - mn;
    if (d) { sa = l > .5 ? d / (2 - mx - mn) : d / (mx + mn); h = mx === r ? (g - b) / d + (g < b ? 6 : 0) : mx === g ? (b - r) / d + 2 : (r - g) / d + 4; h /= 6; }
    sa = Math.min(1, sa * sat); l = Math.min(.92, l + lift * (1 - l));
    function f(p, q, t) { if (t < 0) t += 1; if (t > 1) t -= 1; return t < 1 / 6 ? p + (q - p) * 6 * t : t < 1 / 2 ? q : t < 2 / 3 ? p + (q - p) * (2 / 3 - t) * 6 : p; }
    var q = l < .5 ? l * (1 + sa) : l + sa - l * sa, pp = 2 * l - q;
    var o = [f(pp, q, h + 1 / 3), f(pp, q, h), f(pp, q, h - 1 / 3)].map(function (v) { return Math.round(v * 255); });
    return '#' + ((1 << 24) + (o[0] << 16) + (o[1] << 8) + o[2]).toString(16).slice(1);
  }
  function chaikin(pts, it) { for (var k = 0; k < it; k++) { var o = [pts[0]]; for (var i = 0; i < pts.length - 1; i++) { var a = pts[i], b = pts[i + 1]; o.push([.75 * a[0] + .25 * b[0], .75 * a[1] + .25 * b[1]], [.25 * a[0] + .75 * b[0], .25 * a[1] + .75 * b[1]]); } o.push(pts[pts.length - 1]); pts = o; } return pts; }
  function resample(pts, N) { var seg = [0]; for (var i = 1; i < pts.length; i++) seg.push(seg[i - 1] + Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1])); var L = seg[seg.length - 1], out = [], j = 0; for (var k = 0; k < N; k++) { var d = L * k / (N - 1); while (j < pts.length - 2 && seg[j + 1] < d) j++; var f = (d - seg[j]) / Math.max(1e-9, seg[j + 1] - seg[j]); out.push([pts[j][0] + (pts[j + 1][0] - pts[j][0]) * f, pts[j][1] + (pts[j + 1][1] - pts[j][1]) * f]); } return { P: out, L: L }; }

  /* ---------- Profil complet et zones ---------- */
  var profCache = {};
  function buildProfile(key) {
    if (profCache[key]) return profCache[key];
    var def = SHAPES[key], keys;
    if (def.kind === 'plate') keys = def.keys;
    else {
      var o = def.outer, top = o[o.length - 1];
      if (def.lid) keys = o.concat(def.lid); else {
      var inner = o.slice().reverse().filter(function (p) { return p[1] > def.floor; }).map(function (p) { return [Math.max(.05, p[0] - def.t), p[1]]; });
      keys = o.concat([[top[0] - def.t * .5, top[1] + .1]], inner.slice(1), [[0, def.floor]]);
      }
    }
    var sm = chaikin(keys, 2), N = 400, rs = resample(sm, N), P = rs.P, L = rs.L, ds = L / (N - 1);
    var r = P.map(function (p) { return Math.max(p[0], 0); }), y = P.map(function (p) { return p[1]; });
    var zone = new Array(N), iEdge, i, maxR = Math.max.apply(null, r), firstRaw = -1, lastRaw = -1;
    if (def.kind === 'plate') {
      iEdge = r.indexOf(maxR);
      for (i = iEdge + 1; i < N; i++) if (y[i] < .08) { if (firstRaw < 0) firstRaw = i; lastRaw = i; }
      for (i = 0; i < N; i++) {
        if (Math.abs(i - iEdge) * ds < .2) zone[i] = 'raw';
        else if (i < iEdge) zone[i] = 'top';
        else if (i >= firstRaw && i <= lastRaw) zone[i] = 'raw';
        else zone[i] = i > lastRaw ? 'base' : 'under';
      }
    } else {
      var maxY = Math.max.apply(null, y); iEdge = y.indexOf(maxY);
      for (i = 0; i < iEdge; i++) if (y[i] < .07) { if (firstRaw < 0) firstRaw = i; lastRaw = i; }
      for (i = 0; i < N; i++) {
        if (Math.abs(i - iEdge) * ds < .18 && !def.lid) zone[i] = 'raw';
        else if (i < iEdge) zone[i] = i < firstRaw ? 'base' : (i <= lastRaw ? 'raw' : 'outer');
        else zone[i] = 'inner';
      }
    }
    var p = { def: def, P: P, L: L, N: N, ds: ds, r: r, y: y, zone: zone, iEdge: iEdge, maxR: maxR };
    profCache[key] = p;
    return p;
  }

  /* ---------- Peinture de la texture ---------- */
  function paint(prof, d, ctx, rc, W) {
    var H = W, N = prof.N, L = prof.L, ds = prof.ds, r = prof.r, zone = prof.zone, def = prof.def;
    var clay = CLAYS[d.clay] || CLAYS.blanche, fond = d.fond === NATURAL ? NATURAL_HEX : vivid(hexOf(d.fond), VIV.fs, VIV.fl), col = vivid(hexOf(d.couleur), VIV.s, VIV.l);
    function Y(i) { return (1 - i / (N - 1)) * H; }
    function pxX(cm, i) { return cm / (2 * Math.PI * Math.max(r[i], .35)) * W; }
    function pxY(cm) { return cm / L * H; }
    function isZ(i, list) { return list.indexOf(zone[i]) >= 0; }
    function range(list) { var a = -1, b = -1; for (var i = 0; i < N; i++) if (isZ(i, list)) { if (a < 0) a = i; b = i; } return [a, b]; }
    function wrap(fn) { [-W, 0, W].forEach(function (off) { ctx.save(); ctx.translate(off, 0); fn(); ctx.restore(); }); }
    var glazeR = '#454545', rawR = '#e2e2e2';

    ctx.globalAlpha = 1; ctx.fillStyle = fond; ctx.fillRect(0, 0, W, H);
    rc.fillStyle = glazeR; rc.fillRect(0, 0, W, H);
    /* légères variations d'émail */
    var R0 = rng(97);
    for (var k = 0; k < 1500; k++) { var ii = Math.floor(R0() * N); if (zone[ii] === 'raw') continue; var s0 = .03 + R0() * .05; ctx.globalAlpha = .25 + R0() * .3; ctx.fillStyle = shade(fond, -.07); ctx.beginPath(); ctx.ellipse(R0() * W, Y(ii), Math.min(pxX(s0, ii), W / 8), pxY(s0), 0, 0, Math.PI * 2); ctx.fill(); }
    ctx.globalAlpha = 1;

    /* dessous de la pièce : toujours émaillé blanc, sans motif */
    var dip = dipMode(d);
    ctx.fillStyle = NATURAL_HEX; ctx.globalAlpha = 1;
    for (var iu = 0; iu < N && !dip; iu++) { if (zone[iu] !== 'under' && zone[iu] !== 'base') continue; ctx.fillRect(0, Y(iu) - H / (N - 1) * .6, W, H / (N - 1) * 1.2 + 1); }

    /* terre rouge : l'intérieur des pièces creuses reste en terre cuite rouge vernie, sans peinture */
    var terraIn = d.clay === 'rouge' && !dip && def.kind !== 'plate' && def.group !== 'Assiettes' && !def.lid;
    if (terraIn) {
      var TR = '#8f4124', RT = rng(55);
      ctx.globalAlpha = 1; ctx.fillStyle = TR;
      for (var it = 0; it < N; it++) { if (zone[it] !== 'inner') continue; ctx.fillRect(0, Y(it) - H / (N - 1) * .6, W, H / (N - 1) * 1.2 + 1); }
      for (var kt = 0; kt < 2500; kt++) { var ix = Math.floor(RT() * N); if (zone[ix] !== 'inner') continue; ctx.globalAlpha = .18 + RT() * .25; ctx.fillStyle = RT() < .5 ? '#7a3519' : '#a65530'; ctx.beginPath(); ctx.ellipse(RT() * W, Y(ix), Math.min(pxX(.05 + RT() * .12, ix), W / 8), pxY(.05 + RT() * .1), 0, 0, Math.PI * 2); ctx.fill(); }
      ctx.globalAlpha = 1;
    }

    function stripe(xc0, swirl, wcm, i0, i1, seed, taper, angR) {
      if (i1 <= i0) return;
      var nz = noise1(seed), nz2 = noise1(seed + 99), left = [], right = [];
      for (var i = i0; i <= i1; i += 2) {
        var f = (i - i0) / Math.max(1, i1 - i0), de = Math.min(i - i0, i1 - i) * ds;
        var tp = taper ? (de < .3 ? .45 + .55 * Math.sqrt(de / .3) : 1) : 1;
        var half = (angR ? wcm / 2 / (2 * Math.PI * angR) * W : pxX(wcm / 2, i)) * tp * (.96 + .08 * nz2(i * ds * .35));
        var xc = xc0 + swirl * f * W + pxX(.035, i) * (nz(i * ds * .4) - .5) * 2, wob = pxX(.012, i);
        left.push([xc - half + wob * (nz(i * ds * 3.1 + 7) - .5) * 2, Y(i)]);
        right.push([xc + half + wob * (nz(i * ds * 3.3 + 29) - .5) * 2, Y(i)]);
      }
      wrap(function () {
        ctx.beginPath(); left.forEach(function (p, k) { k ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1]); });
        for (var k = right.length - 1; k >= 0; k--) ctx.lineTo(right[k][0], right[k][1]);
        ctx.closePath(); ctx.globalAlpha = .94; ctx.fillStyle = col; ctx.fill();
        ctx.lineCap = 'round';
        for (var s = 0; s < 4; s++) {
          var tt = .2 + s * .2; ctx.strokeStyle = shade(col, s % 2 ? -.16 : .2); ctx.globalAlpha = .14;
          ctx.lineWidth = Math.max(1.2, Math.abs(right[0][0] - left[0][0]) * .12);
          ctx.beginPath(); left.forEach(function (p, k) { var q = right[k], x = p[0] + (q[0] - p[0]) * tt; k ? ctx.lineTo(x, p[1]) : ctx.moveTo(x, p[1]); }); ctx.stroke();
        }
      });
      ctx.globalAlpha = 1;
    }
    function band(i0, i1, seed, ampCm) {
      if (i1 <= i0) return;
      var nz = noise1(seed), nz2 = noise1(seed + 5), amp = pxY(ampCm || .03), steps = 96, top = [], bot = [];
      for (var k = 0; k <= steps; k++) { var x = k / steps * W; top.push([x, Y(i1) + (nz(k * .35) - .5) * 2 * amp]); bot.push([x, Y(i0) + (nz2(k * .35) - .5) * 2 * amp]); }
      ctx.beginPath(); top.forEach(function (p, k) { k ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1]); });
      for (var k2 = bot.length - 1; k2 >= 0; k2--) ctx.lineTo(bot[k2][0], bot[k2][1]);
      ctx.closePath(); ctx.globalAlpha = .94; ctx.fillStyle = col; ctx.fill();
      ctx.globalAlpha = .12; ctx.strokeStyle = shade(col, .22); ctx.lineWidth = Math.max(1.2, (Y(i0) - Y(i1)) * .12);
      for (var s = 0; s < 2; s++) { var tt = .33 + s * .33; ctx.beginPath(); top.forEach(function (p, k) { var yy = p[1] + (bot[k][1] - p[1]) * tt; k ? ctx.lineTo(p[0], yy) : ctx.moveTo(p[0], yy); }); ctx.stroke(); }
      ctx.globalAlpha = 1;
    }
    function dot(i, radCm) { /* point central d'un motif cercles */
      ctx.globalAlpha = .94; ctx.fillStyle = col; ctx.fillRect(0, Y(i) - pxY(radCm) * .5, W, pxY(radCm));
      ctx.globalAlpha = 1;
    }
    function bandsAlong(list, h, gap, fromCenter, seed, startAt) {
      var rg = range(list); if (rg[0] < 0) return;
      var a = rg[0], b = rg[1], len = (b - a) * ds, pos = startAt == null ? gap * .6 : startAt, k = 0;
      while (pos + h < len - gap * .3) {
        var i0, i1;
        if (fromCenter) { i1 = b - Math.round(pos / ds); i0 = b - Math.round((pos + h) / ds); }
        else { i0 = a + Math.round(pos / ds); i1 = a + Math.round((pos + h) / ds); }
        band(Math.min(i0, i1), Math.max(i0, i1), seed + k * 7);
        pos += h + gap; k++;
      }
    }
    function speckle(list, density) {
      var idx = [], w = [], tot = 0;
      for (var i = 0; i < N; i++) if (isZ(i, list) && r[i] > .45) { tot += r[i]; idx.push(i); w.push(tot); }
      if (!idx.length) return;
      var area = tot * ds * 2 * Math.PI, count = Math.round(area * density), RR = rng(424242), cl = noise1(77);
      for (var k = 0; k < count; k++) {
        var target = RR() * tot, lo = 0, hi = w.length - 1;
        while (lo < hi) { var m = (lo + hi) >> 1; if (w[m] < target) lo = m + 1; else hi = m; }
        var i2 = idx[lo], u = RR();
        if (RR() > .35 + .65 * cl(u * 24 + i2 * ds * .9)) continue;
        var size = .035 + .26 * Math.pow(RR(), 3.2);
        ctx.globalAlpha = .72 + RR() * .28;
        ctx.fillStyle = RR() < .25 ? shade(col, -.15) : (RR() < .2 ? shade(col, .15) : col);
        var yy = Y(i2) + (RR() - .5) * pxY(ds), rx = Math.min(pxX(size, i2), W / 6), ry = pxY(size);
        (function (x, y0, a, b) { wrap(function () { ctx.beginPath(); ctx.ellipse(x, y0, a, b, 0, 0, Math.PI * 2); ctx.fill(); }); })(u * W, yy, rx, ry);
      }
      ctx.globalAlpha = 1;
    }

    /* rayures parallèles sur toute l'assiette (vue de dessus), calculées pixel par pixel */
    function planarStripes(list, angle, period, wcm, seed) {
      ctx.globalAlpha = 1;
      var rows = [], yy;
      for (yy = 0; yy < H; yy++) { var fi = (1 - (yy + .5) / H) * (N - 1), i = Math.round(fi); if (isZ(i, list)) rows.push(yy); }
      if (!rows.length) return;
      var y0 = rows[0], y1 = rows[rows.length - 1], img = ctx.getImageData(0, y0, W, y1 - y0 + 1), data = img.data;
      var c = parseInt(col.slice(1), 16), cr = c >> 16, cg = c >> 8 & 255, cb = c & 255;
      var ca = Math.cos(angle), sa = Math.sin(angle), nz = noise1(seed), nz2 = noise1(seed + 31), nz3 = noise1(seed + 57);
      for (var q = 0; q < rows.length; q++) {
        yy = rows[q];
        var f = (1 - (yy + .5) / H) * (N - 1), i0 = Math.floor(f), t = f - i0, rad = r[i0] + ((r[Math.min(N - 1, i0 + 1)] || 0) - r[i0]) * t;
        var pxPerCm = W / (2 * Math.PI * Math.max(rad, .3)), aa = 1 / Math.max(pxPerCm, .5);
        var base = (yy - y0) * W * 4;
        for (var x = 0; x < W; x++) {
          var ph = x / W * Math.PI * 2, X = rad * Math.sin(ph), Z = rad * Math.cos(ph);
          var u = X * ca + Z * sa, v = -X * sa + Z * ca;
          var kk = Math.floor(u / period + .5), cu = kk * period;
          var half = wcm / 2 * (.95 + .1 * nz2(v * .12 + kk * 9.7)) + (nz(v * .6 + kk * 13.1) - .5) * .035;
          var dist = Math.abs(u - cu - (nz3(v * .15 + kk * 5.3) - .5) * .09) - half;
          var a = dist < -aa ? 1 : (dist > aa ? 0 : .5 - dist / (2 * aa));
          if (a <= 0) continue;
          a *= .94;
          var p = base + x * 4;
          data[p] = data[p] + (cr - data[p]) * a; data[p + 1] = data[p + 1] + (cg - data[p + 1]) * a; data[p + 2] = data[p + 2] + (cb - data[p + 2]) * a;
        }
      }
      ctx.putImageData(img, 0, y0);
    }

    var m = d.motif, st = def.stripes, bd = def.bands;
    if (def.kind === 'plate') {
      var tr = range(['top']);
      if (m === 'rayuresV') { var per = def.R * 2 / 6.6; planarStripes(['top'], .52, per, per * .5, 2024); }
      if (m === 'rayuresH') { var hb = def.R * .085; bandsAlong(['top'], hb, hb * 1.1, true, 600, def.R * .18); }
      if (m === 'cercles') { dot(tr[0] + 1, .5); bandsAlong(['top'], .42, .42, true, 800, .7); }
      if (m === 'taches') speckle(['top'], 9);
    } else {
      var orng = range(['outer']), inr = range(['inner']);
      if (m === 'rayuresV') {
        var oTop = orng[1] - 1; if (def.neckY) { while (oTop > orng[0] && prof.y[oTop] > def.neckY - .25) oTop--; }
        for (var k4 = 0; k4 < st.n; k4++) stripe((k4 + .5) / st.n * W, 0, st.w, orng[0] + 1, oTop, 1000 + k4 * 13, def.lid ? true : false, st.ang);
        /* pièces ouvertes (assiettes creuses, bols, saladiers) : rayures à l'extérieur seulement, intérieur uni */
        if (def.lid && !terraIn) { var l0 = prof.iEdge + Math.round(.25 / ds), l1 = prof.iEdge + Math.round(def.lidBand / ds); for (var k5 = 0; k5 < st.n; k5++) stripe((k5 + .5) / st.n * W, 0, st.w * .55, l0, l1, 3000 + k5 * 11, true); }
      }
      if (m === 'rayuresH') bandsAlong(['outer'], bd.h, bd.gap, false, 500);
      if (m === 'cercles') {
        bandsAlong(['outer'], .42, .42, false, 700, .5);
        if (!terraIn) { dot(inr[1] - 1, .5); bandsAlong(['inner'], .42, .42, true, 900, .7); }
      }
      if (m === 'taches') speckle(terraIn ? ['outer'] : ['outer', 'inner'], 9);
    }

    /* uni terre rouge : trempage en biais, une partie de la terre cuite reste apparente (mate) */
    var RAWC = parseInt(clay.raw.slice(1), 16), rr0 = RAWC >> 16, rg0 = RAWC >> 8 & 255, rb0 = RAWC & 255;
    function dipChord() { /* assiettes : un segment droit de terre cuite sur le bord, dessus et dessous */
      var R = prof.maxR, cut = R * .66, ang = 2.35, ca = Math.cos(ang), sa = Math.sin(ang), nz = noise1(4242), gr = noise1(515);
      var img = ctx.getImageData(0, 0, W, H), dt = img.data, rimg = rc.getImageData(0, 0, W, H), rd = rimg.data;
      for (var yy = 0; yy < H; yy++) {
        var f = (1 - (yy + .5) / H) * (N - 1), i0 = Math.floor(f), t = f - i0, rad = r[i0] + ((r[Math.min(N - 1, i0 + 1)] || 0) - r[i0]) * t;
        if (rad < cut - .3 || zone[Math.round(f)] === 'raw') continue;
        var aa = 1 / Math.max(W / (2 * Math.PI * Math.max(rad, .3)), .5) * 1.2;
        for (var x = 0; x < W; x++) {
          var ph = x / W * Math.PI * 2, X = rad * Math.sin(ph), Z = rad * Math.cos(ph);
          var u = X * ca + Z * sa, v = -X * sa + Z * ca;
          var dist = u - (cut + (nz(v * .45 + 9) - .5) * .22);
          var a = dist > aa ? 1 : (dist < -aa ? 0 : .5 + dist / (2 * aa));
          if (a <= 0) continue;
          var p = (yy * W + x) * 4, g = (gr(x * .9 + yy * 1.7) - .5) * 26;
          dt[p] += (rr0 + g - dt[p]) * a; dt[p + 1] += (rg0 + g * .7 - dt[p + 1]) * a; dt[p + 2] += (rb0 + g * .5 - dt[p + 2]) * a;
          rd[p] += (226 - rd[p]) * a; rd[p + 1] += (226 - rd[p + 1]) * a; rd[p + 2] += (226 - rd[p + 2]) * a;
        }
      }
      ctx.putImageData(img, 0, 0); rc.putImageData(rimg, 0, 0);
    }
    function dipBand() { /* pièces creuses : bande de terre cuite sous le bord, plus haute d'un côté */
      var o = range(['outer']); if (o[0] < 0) return;
      /* cendrier à couvercle : la pièce est tenue par le col, la terre cuite reste sous le col */
      if (def.lid && def.neckY) { var oN = o[1]; while (oN > o[0] && prof.y[oN] > def.neckY - .1) oN--; o = [o[0], oN]; }
      var yTop = prof.y[o[1]], hgt = yTop - prof.y[o[0]], nz = noise1(888), steps = 512, pts = [];
      var yRim = def.lid ? Y(o[1]) : Y(Math.min(N - 1, prof.iEdge + Math.round(.2 / ds)));
      for (var k = 0; k <= steps; k++) {
        /* croissant : épais d'un côté, il s'amincit puis disparaît, l'émail remonte jusqu'au bord */
        var th = k / steps * Math.PI * 2, band = Math.min(hgt * .4, 2.6 * (Math.cos(th - 5.8) + .25) / 1.25 + (nz(k * .07) - .5) * .15);
        var i = o[1];
        if (band > 0) { var yB = yTop - band; while (i > o[0] && prof.y[i] > yB) i--; }
        pts.push([k / steps * W, band > 0 ? Y(i) : yRim]);
      }
      /* là où l'artisan tient la pièce, un peu de terre cuite reste aussi à l'intérieur, juste sous le bord */
      var inr = range(['inner']), yTopIn = prof.y[Math.min(N - 1, prof.iEdge + Math.round(.2 / ds))], ptsIn = [];
      for (var k3 = 0; k3 <= steps; k3++) {
        var th3 = k3 / steps * Math.PI * 2, b3 = (2.6 * (Math.cos(th3 - 5.8) + .25) / 1.25) * .38 + (nz(k3 * .07 + 40) - .5) * .1, j = prof.iEdge;
        if (def.lid) b3 = 0;
        if (b3 > 0 && inr[0] >= 0) { var yBi = yTopIn - Math.min(b3, hgt * .16); while (j < inr[1] && prof.y[j] > yBi) j++; }
        ptsIn.push([k3 / steps * W, b3 > 0 ? Y(j) : yRim]);
      }
      function poly(c) { c.beginPath(); c.moveTo(0, yRim); pts.forEach(function (q) { c.lineTo(q[0], q[1]); }); c.lineTo(W, yRim); c.closePath(); c.moveTo(0, yRim); ptsIn.forEach(function (q) { c.lineTo(q[0], q[1]); }); c.lineTo(W, yRim); c.closePath(); }
      ctx.save(); poly(ctx); ctx.globalAlpha = 1; ctx.fillStyle = clay.raw; ctx.fill(); ctx.clip();
      var gg = rng(4711);
      for (var k2 = 0; k2 < 7000; k2++) { var gx = gg() * W, gy = Y(inr[1] >= 0 ? inr[1] : prof.iEdge) + gg() * (Y(o[0]) - Y(inr[1] >= 0 ? inr[1] : prof.iEdge)); ctx.globalAlpha = .28; ctx.fillStyle = gg() < .5 ? clay.grainA : clay.grainB; ctx.beginPath(); ctx.ellipse(gx, gy, 2 + gg() * 3, 2 + gg() * 3, 0, 0, Math.PI * 2); ctx.fill(); }
      ctx.restore(); ctx.globalAlpha = 1;
      poly(rc); rc.fillStyle = rawR; rc.fill();
    }
    if (dip === 'chord') dipChord(); else if (dip === 'band') dipBand();

    /* terre crue : bord et anneau du pied */
    for (var i3 = 0; i3 < N; i3++) {
      if (zone[i3] !== 'raw') continue;
      if (dip && Math.abs(i3 - prof.iEdge) * ds < .3) continue; /* bord des pièces trempées : émaillé (ou terre cuite là où passe le croissant) */
      var y0 = Y(i3) - H / (N - 1) * .6, hh = H / (N - 1) * 1.2 + 1;
      ctx.fillStyle = clay.raw; ctx.fillRect(0, y0, W, hh);
      rc.fillStyle = rawR; rc.fillRect(0, y0, W, hh);
    }
    var cg = rng(31337);
    for (var k6 = 0; k6 < 6000; k6++) { var i4 = Math.floor(cg() * N); if (zone[i4] !== 'raw') continue; ctx.globalAlpha = .3; ctx.fillStyle = cg() < .5 ? clay.grainA : clay.grainB; ctx.beginPath(); ctx.ellipse(cg() * W, Y(i4) + (cg() - .5) * pxY(ds), Math.min(pxX(.03, i4), W / 10), pxY(.03), 0, 0, Math.PI * 2); ctx.fill(); }
    ctx.globalAlpha = 1;
  }

  /* ---------- Géométrie ---------- */
  function buildGeometry(key) {
    var prof = buildProfile(key), def = prof.def;
    var pts = prof.P.map(function (p) { return new THREE.Vector2(Math.max(p[0], 0), p[1]); });
    var geo = new THREE.LatheGeometry(pts, 144), pos = geo.attributes.position, changed = false, k, x, y, z, rad, a;
    var H = Math.max.apply(null, prof.y);
    if (def.spout) {
      var sp = def.spout;
      for (k = 0; k < pos.count; k++) {
        x = pos.getX(k); y = pos.getY(k); z = pos.getZ(k); rad = Math.hypot(x, z); if (rad < .01) continue;
        a = Math.atan2(x, z);
        var dA = Math.abs(Math.atan2(Math.sin(a - Math.PI), Math.cos(a - Math.PI)));
        var w = Math.exp(-Math.pow(dA / sp.width, 2)), hgt = Math.pow(smooth(sp.from, H + .1, y), 1.7), kk = w * hgt;
        var pinch = Math.exp(-Math.pow((dA - sp.width * 1.9) / (sp.width * .8), 2)) * hgt * .28;
        var s = (rad + sp.amp * kk - pinch) / rad;
        pos.setXYZ(k, x * s, y + (sp.lift == null ? .35 : sp.lift) * kk, z * s);
      }
      changed = true;
    }
    if (def.notches) {
      var nt = def.notches;
      for (k = 0; k < pos.count; k++) {
        x = pos.getX(k); y = pos.getY(k); z = pos.getZ(k);
        if (y < H - nt.depth - .25) continue;
        a = Math.atan2(x, z);
        var best = 9;
        for (var n = 0; n < nt.n; n++) { var c = Math.PI / nt.n + n * 2 * Math.PI / nt.n; var dd = Math.abs(Math.atan2(Math.sin(a - c), Math.cos(a - c))); if (dd < best) best = dd; }
        var g = Math.exp(-Math.pow(best / nt.width, 4)), lift = smooth(H - nt.depth - .25, H, y);
        pos.setY(k, y - nt.depth * g * lift);
      }
      changed = true;
    }
    if (changed) geo.computeVertexNormals();
    return { geo: geo, prof: prof };
  }
  function buildHandle(def) {
    var h = def.handle, curve, geo;
    if (h.type === 'strap') {
      curve = new THREE.CatmullRomCurve3(h.pts.map(function (p) { return new THREE.Vector3(0, p[1], p[0]); }), false, 'centripetal');
      geo = new THREE.TubeGeometry(curve, 96, h.r, 18, false);
    } else {
      var R = def.outer[def.outer.length - 2][0], pts = [];
      for (var i = 0; i < 48; i++) { var t = i / 48 * Math.PI * 2; pts.push(new THREE.Vector3(0, h.cy + Math.sin(t) * h.cr, R + h.off + Math.cos(t) * h.cr)); }
      curve = new THREE.CatmullRomCurve3(pts, true);
      geo = new THREE.TubeGeometry(curve, 120, h.r, 18, true);
    }
    geo.scale(h.sx || 1, 1, 1);
    return geo;
  }

  /* ---------- Ambiance atelier (page de création seulement : option { scene: 'atelier' }) ----------
     La pièce est posée sur une tournette de décorateur qui tourne avec elle, sur un bureau en bois massif,
     devant un mur à la chaux au soleil, un olivier en pot et une étagère de poteries. Les bols d'émail prennent
     les couleurs choisies. La pièce reste éclairée de façon neutre : ses couleurs restent fidèles. */
  var TAU = Math.PI * 2;
  function mkCanvas(w, h) { var c = document.createElement('canvas'); c.width = w; c.height = h; return c; }
  function canvasTex(c, rx, ry) {
    var t = new THREE.CanvasTexture(c); t.encoding = THREE.sRGBEncoding; t.anisotropy = 8;
    if (rx) { t.wrapS = t.wrapT = THREE.RepeatWrapping; t.repeat.set(rx, ry); }
    return t;
  }
  function lin(hex) { return new THREE.Color(hex).convertSRGBToLinear(); }
  function boxPass(src, dst, w, h, r, horiz) {
    var n = horiz ? w : h, m = horiz ? h : w, step = horiz ? 4 : w * 4, inv = 1 / (2 * r + 1);
    for (var j = 0; j < m; j++) {
      var base = horiz ? j * w * 4 : j * 4;
      for (var c = 0; c < 4; c++) {
        var s = 0, i;
        for (i = -r; i <= r; i++) s += src[base + Math.min(n - 1, Math.max(0, i)) * step + c];
        for (i = 0; i < n; i++) {
          dst[base + i * step + c] = s * inv;
          s += src[base + Math.min(n - 1, i + r + 1) * step + c] - src[base + Math.max(0, i - r) * step + c];
        }
      }
    }
  }
  /* flou d'arrière-plan (3 passes de flou en boîte ≈ gaussien), identique sur tous les navigateurs */
  function blurCtx(x, w, h, r) { var img = x.getImageData(0, 0, w, h), a = img.data, b = new Uint8ClampedArray(a.length); for (var k = 0; k < 3; k++) { boxPass(a, b, w, h, r, true); boxPass(b, a, w, h, r, false); } x.putImageData(img, 0, 0); }
  function softSpot(x, cx, cy, r, rgb, a) { var g = x.createRadialGradient(cx, cy, 0, cx, cy, r); g.addColorStop(0, 'rgba(' + rgb + ',' + a + ')'); g.addColorStop(1, 'rgba(' + rgb + ',0)'); x.fillStyle = g; x.fillRect(cx - r, cy - r, r * 2, r * 2); }
  function tiled(S, cx, cy, r, fn) { for (var ox = -1; ox <= 1; ox++) for (var oy = -1; oy <= 1; oy++) { var px = cx + ox * S, py = cy + oy * S; if (px + r < 0 || px - r > S || py + r < 0 || py - r > S) continue; fn(px, py); } }

  /* ---------- Décor méditerranéen de l'atelier (rien n'est flou) ----------
     Bureau taillé dans une seule pièce de bois (fil, cernes, nœuds), mur à la chaux en crépi,
     soleil de fenêtre, olivier en pot dont les feuilles font de vraies ombres sur le mur,
     étagère de poteries. P permet d'ajuster les réglages. */
  function valueNoise(seed, gw, gh) {
    var r = rng(seed), g = new Float32Array(gw * gh), i;
    for (i = 0; i < g.length; i++) g[i] = r();
    return function (x, y) {
      var xi = Math.floor(x), yi = Math.floor(y), fx = x - xi, fy = y - yi;
      fx = fx * fx * (3 - 2 * fx); fy = fy * fy * (3 - 2 * fy);
      var x0 = (xi % gw + gw) % gw, y0 = (yi % gh + gh) % gh, x1 = (x0 + 1) % gw, y1 = (y0 + 1) % gh;
      var a = g[y0 * gw + x0], b = g[y0 * gw + x1], c = g[y1 * gw + x0], d = g[y1 * gw + x1];
      return a + (b - a) * fx + (c - a) * fy + (a - b - c + d) * fx * fy;
    };
  }
  function rgbOf(hex) { var n = parseInt(hex.slice(1), 16); return [n >> 16, n >> 8 & 255, n & 255]; }

  /* plateau du bureau : 240 × 120 cm, le haut de l'image touche le mur */
  function deskCanvas(P) {
    var W = P.deskW, H = W / 2, CM = W / 240, c = mkCanvas(W, H), x = c.getContext('2d'), img = x.createImageData(W, H), d = img.data;
    var R = rng(4242), n1 = valueNoise(11, 64, 64), n2 = valueNoise(12, 64, 64), n3 = valueNoise(13, 64, 64);
    var GW = W / 4 + 1, GH = H / 4 + 1, warp = new Float32Array(GW * GH), tone = new Float32Array(GW * GH), gx, gy, i;
    for (gy = 0; gy < GH; gy++) for (gx = 0; gx < GW; gx++) {
      var u = gx * 4 / W, v = gy * 4 / H;
      warp[gy * GW + gx] = (n1(u * 2.2, v * 4) - .5) * P.warp + (n2(u * 7, v * 11) - .5) * P.warp * .22;
      tone[gy * GW + gx] = n3(u * 3, v * 2.5) - .5;
    }
    var knots = P.knots.map(function (k) { return { x: (k[0] + 120) * CM, y: k[1] * CM, r: k[2] }; });
    var fib = new Float32Array(16384), grain = new Float32Array(4096); for (i = 0; i < fib.length; i++) fib[i] = R(); for (i = 0; i < grain.length; i++) grain[i] = R() - .5;
    var L = rgbOf(P.woodLight), M = rgbOf(P.woodMid), Dk = rgbOf(P.woodDark), K = rgbOf(P.knot);
    for (var py = 0; py < H; py++) {
      var fy = py / 4, gy0 = Math.floor(fy), ty = fy - gy0, gy1 = Math.min(GH - 1, gy0 + 1);
      for (var px = 0; px < W; px++) {
        var fx = px / 4, gx0 = Math.floor(fx), tx = fx - gx0, gx1 = Math.min(GW - 1, gx0 + 1);
        var a = gy0 * GW + gx0, b = gy0 * GW + gx1, cc = gy1 * GW + gx0, dd = gy1 * GW + gx1;
        var w = warp[a] + (warp[b] - warp[a]) * tx + (warp[cc] - warp[a]) * ty + (warp[a] - warp[b] - warp[cc] + warp[dd]) * tx * ty;
        var tn = tone[a] + (tone[b] - tone[a]) * tx + (tone[cc] - tone[a]) * ty;
        var yc = py / CM + w, core = 0, rim = 0, qc = 0;
        for (var k = 0; k < knots.length; k++) {
          var kn = knots[k], dx = (px - kn.x) / CM, dy = (py - kn.y) / CM;
          if (dx > 16 * kn.r || dx < -16 * kn.r || dy > 6 * kn.r || dy < -6 * kn.r) continue;
          var e = dx * dx / 5 + dy * dy, s2 = kn.r * kn.r;
          yc += kn.r * 3.2 * Math.exp(-e / (s2 * 4.5));          /* le fil contourne le nœud */
          var q = Math.sqrt(dx * dx / 1.6 + dy * dy) / kn.r;
          if (q < 1) { core = Math.max(core, 1 - q * q * .35); qc = q; }
          else if (q < 1.35) rim = Math.max(rim, 1 - (q - 1) / .35);
        }
        var t = yc / P.ring, f = t - Math.floor(t), late = f * f * f * (1 - smooth(.94, 1, f) * .8);
        var fb = fib[Math.floor(yc * 14.5) & 16383] * .7 + fib[(Math.floor(yc * 52) + 777) & 16383] * .3;
        var br = .955 + fb * .085 + grain[(px * 7 + py * 13) & 4095] * .025, mt = .5 + tn * 1.3;
        var o = (py * W + px) * 4;
        for (var ch = 0; ch < 3; ch++) {
          var base = L[ch] + (M[ch] - L[ch]) * mt, col = (base + (Dk[ch] - base) * late * P.ringDepth) * br;
          if (core) col = col + (K[ch] * (.9 + .25 * Math.cos(qc * 11)) - col) * core;
          if (rim) col = col + (K[ch] - col) * rim * .45;
          d[o + ch] = col;
        }
        d[o + 3] = 255;
      }
    }
    x.putImageData(img, 0, 0);
    return c;
  }

  /* crépi à la chaux : enduit écrasé à la taloche, éclairé en lumière rasante (motif raccordable, 64 cm) */
  function crepiCanvas(P) {
    var S = 1024, c = mkCanvas(S, S), x = c.getContext('2d'), R = rng(909), i;
    x.fillStyle = '#808080'; x.fillRect(0, 0, S, S);
    for (var k = 0; k < P.blobs; k++) {
      var cx = R() * S, cy = R() * S, r = 3 + Math.pow(R(), 2.2) * 20, up = R() > .42, al = .08 + R() * .2;
      tiled(S, cx, cy, r, function (px, py) { softSpot(x, px, py, r, up ? '255,255,255' : '0,0,0', al); });
    }
    var hm = x.getImageData(0, 0, S, S).data, out = x.createImageData(S, S), o = out.data, Hh = new Float32Array(S * S);
    for (i = 0; i < S * S; i++) Hh[i] = hm[i * 4] / 255 + (R() - .5) * P.sand;
    var base = rgbOf(P.lime), Lx = -.55, Ly = .6, Lz = .58, amp = P.relief;
    for (var y = 0; y < S; y++) {
      var yu = (y + S - 1) % S, yd = (y + 1) % S;
      for (var xx = 0; xx < S; xx++) {
        var xl = (xx + S - 1) % S, xr = (xx + 1) % S, h = Hh[y * S + xx];
        var nx = (Hh[y * S + xl] - Hh[y * S + xr]) * amp, ny = (Hh[yd * S + xx] - Hh[yu * S + xx]) * amp;
        var dot = (nx * Lx + ny * Ly + Lz) / Math.sqrt(nx * nx + ny * ny + 1);
        var s = Math.max(.7, Math.min(1.12, 1 + P.shade * (dot - Lz))) * (.95 + .07 * h), p = (y * S + xx) * 4;
        o[p] = base[0] * s; o[p + 1] = base[1] * s; o[p + 2] = base[2] * s; o[p + 3] = 255;
      }
    }
    x.putImageData(out, 0, 0);
    return c;
  }

  /* lumière du mur (260 × 140 cm) : ombre douce de la pièce, tache de soleil de fenêtre, petites ombres de feuillage lointain */
  function wallLightCanvas(P) {
    var W = 1024, H = 552, PX = W / 260, c = mkCanvas(W, H), x = c.getContext('2d'), R = rng(5151);
    function X(cm) { return (cm + 130) * PX; } function Y(cm) { return H - cm * PX; }
    x.fillStyle = P.shadeTint; x.fillRect(0, 0, W, H);
    var g = x.createRadialGradient(X(-10), Y(40), 10, X(-10), Y(40), 150 * PX); g.addColorStop(0, 'rgba(255,250,240,.16)'); g.addColorStop(1, 'rgba(255,250,240,0)');
    x.fillStyle = g; x.fillRect(0, 0, W, H);
    var s = P.sun;
    x.save(); x.beginPath(); x.moveTo(X(s[0]), Y(140)); x.lineTo(X(s[1]), Y(140)); x.lineTo(X(s[3]), Y(0)); x.lineTo(X(s[2]), Y(0)); x.closePath(); x.clip();
    x.fillStyle = P.sunTint; x.fillRect(0, 0, W, H);
    /* montant de la fenêtre */
    var m = P.mullion; x.fillStyle = P.shadeTint; x.beginPath(); x.moveTo(X(m[0]), Y(140)); x.lineTo(X(m[0] + m[2]), Y(140)); x.lineTo(X(m[1] + m[2]), Y(0)); x.lineTo(X(m[1]), Y(0)); x.closePath(); x.fill();
    /* feuillage lointain */
    x.fillStyle = P.shadeTint;
    for (var b = 0; b < P.dapple.length; b++) {
      var db = P.dapple[b], bx = X(db[0]), by = Y(db[1]), ang = db[2], len = db[3] * PX;
      for (var l = 0; l < db[4]; l++) {
        var t = l / db[4], lx = bx + Math.cos(ang) * len * t + (R() - .5) * 6, ly = by + Math.sin(ang) * len * t + (R() - .5) * 6;
        x.save(); x.translate(lx, ly); x.rotate(ang + (l % 2 ? .75 : -.75) + (R() - .5) * .5); x.beginPath(); x.ellipse(2.6 * PX, 0, 2.8 * PX, .55 * PX, 0, 0, TAU); x.fill(); x.restore();
      }
    }
    x.restore();
    blurCtx(x, W, H, 2);
    /* pied du mur un peu plus sombre */
    var cs = x.createLinearGradient(0, Y(0), 0, Y(10)); cs.addColorStop(0, 'rgba(70,58,46,.22)'); cs.addColorStop(1, 'rgba(70,58,46,0)');
    x.fillStyle = cs; x.fillRect(0, Y(10), W, 10 * PX);
    return c;
  }

  /* poterie à rayures peintes à la main (vase de l'étagère) */
  function stripeCanvas(base, ink, n, rim, inside) {
    var c = mkCanvas(512, 256), x = c.getContext('2d'), R = rng(77);
    x.fillStyle = base; x.fillRect(0, 0, 512, 256); x.fillStyle = ink;
    for (var i = 0; i < n; i++) {
      var cx = (i + .5) / n * 512, w = 512 / n * .32;
      x.beginPath(); x.moveTo(cx - w, 0);
      for (var y = 0; y <= 256; y += 16) x.lineTo(cx - w + Math.sin(y * .05 + i) * 1.6 + (R() - .5), y);
      for (y = 256; y >= 0; y -= 16) x.lineTo(cx + w + Math.sin(y * .04 + i * 2) * 1.6 + (R() - .5), y);
      x.closePath(); x.fill();
    }
    /* intérieur en terre rouge vernie */
    if (inside) { x.fillStyle = inside; x.fillRect(0, 0, 512, Math.ceil(256 * (1 - rim)) + 3); }
    return c;
  }
  /* hauteur (en v de texture) du bord d'une pièce tournée : au-delà, c'est l'intérieur */
  function rimV(outer, t, floor, n) {
    var top = outer[outer.length - 1];
    var inner = outer.slice().reverse().filter(function (p) { return p[1] > floor; }).map(function (p) { return [Math.max(.05, p[0] - t), p[1]]; });
    var P = resample(chaikin(outer.concat([[top[0] - t * .5, top[1] + .08]], inner.slice(1), [[0, floor]]), 2), n).P, j = 0;
    P.forEach(function (p, i) { if (p[1] > P[j][1]) j = i; });
    return j / (n - 1);
  }

  function buildDecor(v, A, P) {
    var mob = window.innerWidth < 760;
    P = Object.assign({
      D: 45, deskW: mob ? 1024 : 2048, warp: 22, ring: 2.1, ringDepth: .55, woodLight: '#dec6a0', woodMid: '#cfae84', woodDark: '#9f774c', knot: '#6a4529',
      knots: [[-36, 22, 1.4], [-9, 31, 1.5], [30, 50, 1.1], [52, 10, 1.6], [-64, 66, 1.3], [12, 84, .9], [-14, 98, 1.5]],
      lime: '#f2eadd', relief: 8, shade: .7, sand: .06, blobs: 2600, tile: 64,
      shadeTint: '#a69c92', sunTint: '#fff1dc', lmK: 1.36,
      sun: [-70, -30, -30, 18], mullion: [-52, -14, 3],
      dapple: [[-80, 120, .5, 24, 12], [-40, 100, .9, 18, 9], [10, 60, .35, 16, 8], [-62, 88, .2, 14, 7]],
      shelfY: 17, shelfX0: 11, shelfX1: 66, shelfD: 10, plantX: -27, plantZ: 9, plantS: .92, shadow: .3
    }, P || {});
    var scene = v.scene, D = A.D = P.D, out = [];
    function add(m) { scene.add(m); out.push(m); return m; }
    /* bureau */
    var deskTex = canvasTex(deskCanvas(P)); deskTex.anisotropy = 8;
    var desk = add(new THREE.Mesh(new THREE.PlaneGeometry(240, 120), new THREE.MeshStandardMaterial({ map: deskTex, roughness: .58, metalness: 0, envMapIntensity: .4, fog: false })));
    desk.rotation.x = -Math.PI / 2; desk.position.set(0, 0, -D + 60); desk.receiveShadow = true;
    /* mur */
    var crepi = canvasTex(crepiCanvas(P), 260 / P.tile, 140 / P.tile), lm = new THREE.CanvasTexture(wallLightCanvas(P));
    var wgeo = new THREE.PlaneGeometry(260, 140); wgeo.setAttribute('uv2', wgeo.attributes.uv);
    var wall = add(new THREE.Mesh(wgeo, new THREE.MeshBasicMaterial({ map: crepi, lightMap: lm, lightMapIntensity: P.lmK, fog: false, toneMapped: false })));
    wall.position.set(0, 70, -D);
    var catcher = add(new THREE.Mesh(new THREE.PlaneGeometry(260, 140), new THREE.ShadowMaterial({ color: 0x4a3420, opacity: P.shadow, depthWrite: false })));
    catcher.position.set(0, 70, -D + .06); catcher.receiveShadow = true;
    scene.fog = null;
    /* étagère et poteries */
    var shelfMat = new THREE.MeshStandardMaterial({ color: lin('#c9a67b'), roughness: .62, fog: false });
    var shelf = add(new THREE.Mesh(new THREE.BoxGeometry(P.shelfX1 - P.shelfX0, 2.4, P.shelfD), shelfMat));
    shelf.position.set((P.shelfX0 + P.shelfX1) / 2, P.shelfY - 1.2, -D + P.shelfD / 2); shelf.castShadow = shelf.receiveShadow = true;
    var stripeMap = canvasTex(stripeCanvas('#f1ebe0', '#26318c', 11, rimV(sc(SHAPES.pichet.outer, .82), .4, .64, 80), '#9a4a2b'));
    var glazeBlue = new THREE.MeshStandardMaterial({ map: stripeMap, roughness: .32, metalness: 0, envMapIntensity: .55, fog: false });
    var glazeCream = new THREE.MeshStandardMaterial({ color: lin('#efe7da'), roughness: .3, envMapIntensity: .5, fog: false });
    var glazeOchre = new THREE.MeshStandardMaterial({ color: lin('#d4a03c'), roughness: .32, envMapIntensity: .5, fog: false });
    var terra = new THREE.MeshStandardMaterial({ color: lin('#c27650'), roughness: .9, fog: false });
    function sc(o, k) { return o.map(function (p) { return [p[0] * k, p[1] * k]; }); }
    function pot(outer, k, t, mat, x0, y0) { var m = add(new THREE.Mesh(latheGeo(sc(outer, k), t, t * 1.6, 48, 80), mat)); m.position.set(x0, y0, -D + P.shelfD / 2); m.castShadow = m.receiveShadow = true; return m; }
    var y0 = P.shelfY;
    pot(SHAPES.pichet.outer, .82, .4, glazeBlue, P.shelfX0 + 7, y0);
    pot(SHAPES.bol.outer, .78, .35, glazeCream, P.shelfX0 + 18, y0);
    pot(SHAPES.bol.outer, .7, .35, glazeOchre, P.shelfX0 + 18, y0 + 1.6);
    pot(SHAPES['cache-pot-petit'].outer, .72, .45, terra, P.shelfX0 + 29, y0);
    pot(SHAPES.pichet.outer, .7, .4, glazeCream, P.shelfX0 + 40, y0);
    /* olivier en pot */
    var plant = new THREE.Group(); add(plant);
    /* cache-pot Marobali : terre rouge, blanc uni, touche de terre cuite au bord */
    var potM = paintedPiece('cache-pot-grand', window.MB_POT || { clay: 'rouge', motif: 'uni', fond: 'Blanc' }, 768); potM.scale.setScalar(.8); plant.add(potM);
    var soil = new THREE.Mesh(new THREE.CircleGeometry(6.7, 40), new THREE.MeshStandardMaterial({ color: lin('#4d3c2d'), roughness: 1, fog: false }));
    soil.rotation.x = -Math.PI / 2; soil.position.y = 13.9; plant.add(soil);
    var bark = new THREE.MeshStandardMaterial({ color: lin('#7a6a58'), roughness: .9, fog: false });
    function V(p) { return new THREE.Vector3(p[0], p[1], p[2]); }
    var limbs = [
      [[0, 13, 0], [.5, 20, .3], [1.6, 27, .2], [2.2, 32, -.4]],
      [[2.2, 31, -.3], [7, 37, .8], [13, 42, 1.2], [19, 45, .4], [24, 46, -.5]],
      [[2.1, 32, 0], [-1.5, 40, .8], [-5, 48, 0], [-8, 55, -1]],
      [[2.0, 29, .2], [7, 32, 2.6], [13, 33, 4.5], [19, 31, 5.5]],
      [[2.3, 32.5, -.4], [3.8, 41, -1.6], [5.5, 50, -2.6], [8, 58, -3]],
      [[1.4, 25, 0], [-3.5, 28, 1.8], [-8.5, 30, 2.6], [-13, 29, 2]]
    ];
    var curves = limbs.map(function (pts, i) {
      var cv = new THREE.CatmullRomCurve3(pts.map(V));
      var tm = new THREE.Mesh(new THREE.TubeGeometry(cv, 24, i ? .26 : .62, 6, false), bark); tm.castShadow = true; plant.add(tm);
      return cv;
    });
    var lg = new THREE.BufferGeometry(), pos = [], idx = [], N = 8, r;
    for (r = 0; r <= N; r++) {
      var tt = r / N, w = Math.pow(Math.sin(Math.PI * tt), .8) * .085, arch = -.05 * Math.sin(Math.PI * tt);
      pos.push(-w, tt, w * .45 + arch, 0, tt, arch, w, tt, w * .45 + arch);
      if (r) { var a0 = (r - 1) * 3; idx.push(a0, a0 + 3, a0 + 1, a0 + 1, a0 + 3, a0 + 4, a0 + 1, a0 + 4, a0 + 2, a0 + 2, a0 + 4, a0 + 5); }
    }
    lg.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3)); lg.setIndex(idx); lg.computeVertexNormals();
    var LR = rng(321), leaves = [], up = new THREE.Vector3(0, 1, 0);
    curves.forEach(function (cv, i) {
      var n = i ? 30 : 6;
      for (var j = 0; j < n; j++) {
        var t = i ? .18 + .82 * j / (n - 1) : .7 + .3 * j / n, p = cv.getPointAt(t), tg = cv.getTangentAt(t);
        var side = new THREE.Vector3(LR() - .5, LR() - .5, LR() - .5).cross(tg).normalize();
        var a = .55 + LR() * .55, dir = tg.clone().multiplyScalar(Math.cos(a)).addScaledVector(side, Math.sin(a)); dir.y -= .15 + LR() * .2; dir.normalize();
        var q = new THREE.Quaternion().setFromUnitVectors(up, dir).multiply(new THREE.Quaternion().setFromAxisAngle(up, LR() * TAU));
        var len = 4.4 + LR() * 2.4;
        leaves.push({ p: p.addScaledVector(side, .3), q: q, s: len, c: LR() });
      }
    });
    var leafMesh = new THREE.InstancedMesh(lg, new THREE.MeshStandardMaterial({ color: 0xffffff, roughness: .72, side: THREE.DoubleSide, fog: false }), leaves.length);
    var tones = ['#4f5a37', '#59643f', '#63704a', '#7d876a', '#99a08a'], mtx = new THREE.Matrix4(), col = new THREE.Color();
    leaves.forEach(function (lf, k) {
      mtx.compose(lf.p, lf.q, new THREE.Vector3(lf.s, lf.s, lf.s)); leafMesh.setMatrixAt(k, mtx);
      col.set(tones[Math.min(4, Math.floor(Math.pow(lf.c, 1.5) * 5))]).convertSRGBToLinear(); leafMesh.setColorAt(k, col);
    });
    leafMesh.castShadow = true; plant.add(leafMesh);
    plant.position.set(P.plantX, 0, -D + P.plantZ); plant.scale.setScalar(P.plantS);
    plant.traverse(function (o) { if (o.isMesh) o.castShadow = true; });
    /* lumière de fenêtre : ombres nettes sur le bureau et le mur */
    var key = v.key;
    A.light = function (tg) {
      var dir = new THREE.Vector3(-7, 15, 8).normalize(), S = 88, scam = key.shadow.camera;
      key.position.copy(tg).addScaledVector(dir, 170); key.target.position.copy(tg); key.target.updateMatrixWorld();
      scam.left = -S; scam.right = S; scam.top = S; scam.bottom = -S; scam.near = 40; scam.far = 340; scam.updateProjectionMatrix();
    };
    A.decor = out;
    return A;
  }

  /* plateau de la tournette : pierre claire au grain fin, deux cercles de centrage discrets */
  function wheelCanvas() {
    var S = 512, c = mkCanvas(S, S), x = c.getContext('2d'), R = rng(99), cx = S / 2;
    var g = x.createRadialGradient(cx, cx, 0, cx, cx, cx); g.addColorStop(0, '#d9d2c6'); g.addColorStop(1, '#cbc2b4');
    x.fillStyle = g; x.fillRect(0, 0, S, S);
    for (var k = 0; k < 3000; k++) { var a = R() * TAU, rr = Math.sqrt(R()) * cx; x.globalAlpha = .15 + R() * .3; x.fillStyle = R() < .6 ? '#b8b1a7' : '#f8f6f2'; x.fillRect(cx + Math.cos(a) * rr, cx + Math.sin(a) * rr, 1 + R() * 1.4, 1 + R() * 1.4); }
    x.globalAlpha = .32; x.strokeStyle = '#bcb6ad'; x.lineWidth = 1.5;
    [.64, .82].forEach(function (f) { x.beginPath(); x.arc(cx, cx, cx * f, 0, TAU); x.stroke(); });
    x.globalAlpha = 1; return c;
  }

  /* profil de révolution simple (cm) → géométrie légère, pour les accessoires */
  function latheGeo(outer, t, floor, segs, n) {
    var top = outer[outer.length - 1];
    var inner = outer.slice().reverse().filter(function (p) { return p[1] > floor; }).map(function (p) { return [Math.max(.05, p[0] - t), p[1]]; });
    var keys = outer.concat([[top[0] - t * .5, top[1] + .08]], inner.slice(1), [[0, floor]]);
    var rs = resample(chaikin(keys, 2), n);
    return new THREE.LatheGeometry(rs.P.map(function (p) { return new THREE.Vector2(Math.max(0, p[0]), p[1]); }), segs);
  }

  /* une pièce Marobali peinte (même rendu que la pièce créée), utilisée dans le décor */
  function paintedPiece(key, d, W) {
    var built = buildGeometry(key), tex = mkCanvas(W, W), rough = mkCanvas(W, W);
    paint(built.prof, Object.assign({ clay: 'blanche', motif: 'uni', fond: NATURAL, couleur: 'Bleu nuit', shape: key }, d), tex.getContext('2d'), rough.getContext('2d'), W);
    var m = new THREE.Mesh(built.geo, new THREE.MeshPhysicalMaterial({ map: canvasTex(tex), roughnessMap: new THREE.CanvasTexture(rough), roughness: 1, metalness: 0, clearcoat: .35, clearcoatRoughness: .28, envMapIntensity: .45, side: THREE.DoubleSide, fog: false }));
    m.castShadow = m.receiveShadow = true;
    return m;
  }

  function buildAtelier(v) {
    var A = { D: 55, top: 6.65, rw: 10 }, scene = v.scene;
    var mob = window.innerWidth < 760;
    /* tournette : socle en fonte, plateau en alu tourné */
    var iron = new THREE.MeshStandardMaterial({ color: lin('#4a4b4d'), metalness: .08, roughness: .78, fog: false });
    var alu = new THREE.MeshStandardMaterial({ color: lin('#b9bdbe'), metalness: .7, roughness: .36, fog: false });
    var stone = new THREE.MeshStandardMaterial({ color: lin('#c9c1b4'), metalness: 0, roughness: .72, fog: false });
    var aluTop = new THREE.MeshStandardMaterial({ map: canvasTex(wheelCanvas()), metalness: 0, roughness: .66, fog: false });
    aluTop.map.anisotropy = 4;
    var basePts = [[0, 0], [5.6, 0], [5.85, .25], [5.7, .85], [4.3, 1.55], [2.7, 2.9], [1.95, 3.95], [1.75, 4.45], [1.25, 4.6], [1.2, 5.05], [0, 5.05]].map(function (p) { return new THREE.Vector2(p[0], p[1]); });
    var base = new THREE.Mesh(new THREE.LatheGeometry(basePts, 56), iron); base.castShadow = base.receiveShadow = true;
    var head = new THREE.Mesh(new THREE.CylinderGeometry(10, 9.9, 1.6, 96), [stone, aluTop, stone]);
    head.position.y = 5.85; head.castShadow = head.receiveShadow = true;
    scene.add(base); scene.add(head);
    /* bols d'émail aux couleurs choisies, un pinceau */
    var bisque = new THREE.MeshStandardMaterial({ color: lin('#c4825d'), roughness: .88, fog: false });
    var bowlGeo = latheGeo([[0, .15], [1.9, .15], [2.1, 0], [2.6, 0], [2.8, .3], [3.6, 1.2], [4.2, 2.6], [4.4, 4.0], [4.35, 4.3]], .32, .5, 48, 90);
    function glazeBowl() {
      var g = new THREE.Group(), b = new THREE.Mesh(bowlGeo, bisque); b.castShadow = b.receiveShadow = true; g.add(b);
      var liq = new THREE.Mesh(new THREE.CircleGeometry(3.92, 48), new THREE.MeshPhysicalMaterial({ color: 0xffffff, roughness: .12, metalness: 0, clearcoat: 1, clearcoatRoughness: .05, fog: false }));
      liq.rotation.x = -Math.PI / 2; liq.position.y = 3.05; liq.receiveShadow = true; g.add(liq); g.liquid = liq; return g;
    }
    var bowlA = glazeBowl(), bowlB = glazeBowl(); scene.add(bowlA); scene.add(bowlB);
    var brush = new THREE.Group(), wood = new THREE.MeshStandardMaterial({ color: lin('#b98b5c'), roughness: .5, fog: false });
    var bristleMat = new THREE.MeshStandardMaterial({ color: 0xffffff, roughness: .6, fog: false });
    var bristle = new THREE.Mesh(new THREE.ConeGeometry(.42, 2.3, 16), bristleMat); bristle.rotation.z = Math.PI / 2; bristle.position.x = -1.15;
    var ferrule = new THREE.Mesh(new THREE.CylinderGeometry(.36, .34, 1.5, 16), alu); ferrule.rotation.z = Math.PI / 2; ferrule.position.x = .75;
    var handle = new THREE.Mesh(new THREE.CylinderGeometry(.32, .24, 15, 16), wood); handle.rotation.z = Math.PI / 2; handle.position.x = 9;
    [bristle, ferrule, handle].forEach(function (m) { m.castShadow = true; brush.add(m); });
    brush.position.y = .36; scene.add(brush);
    /* pot à pinceaux Marobali : bandes horizontales, intérieur en terre rouge vernie */
    var jar = new THREE.Group();
    var jm = paintedPiece('pot-ustensiles', window.MB_JAR || { clay: 'rouge', motif: 'rayuresH', couleur: 'Terracotta' }, 512); jm.scale.setScalar(.62); jar.add(jm);
    var hGeo = new THREE.CylinderGeometry(.22, .3, 15, 12), fGeo = new THREE.CylinderGeometry(.3, .27, 1.4, 12), bGeo = new THREE.ConeGeometry(.36, 2.2, 12);
    ['#3a2a1f', '#d9733a', '#c9a57b', '#2b36a3'].forEach(function (tc, i) {
      var bg = new THREE.Group(), a = i / 4 * TAU + .4, tilt = .09 + (i % 3) * .06;
      var hm = new THREE.Mesh(hGeo, wood); hm.position.y = 7.5;
      var fm = new THREE.Mesh(fGeo, alu); fm.position.y = 15.7;
      var tm = new THREE.Mesh(bGeo, new THREE.MeshStandardMaterial({ color: lin(tc), roughness: .6, fog: false })); tm.position.y = 17.5;
      [hm, fm, tm].forEach(function (m) { m.castShadow = true; bg.add(m); });
      bg.position.set(Math.cos(a) * 1.3, .8, Math.sin(a) * 1.3); bg.rotation.set(Math.sin(a) * tilt, 0, -Math.cos(a) * tilt);
      jar.add(bg);
    });
    scene.add(jar);

    A.head = head;
    /* la tournette s'adapte à la pièce ; les accessoires restent autour */
    A.fit = function (def, prof) {
      var rw = Math.max(7.5, Math.min(12.5, prof.maxR * 1.12)); A.rw = rw;
      head.scale.set(rw / 10, 1, rw / 10);
      var bs = Math.max(.85, Math.min(1.12, rw / 10)); base.scale.set(bs, 1, bs);
      bowlA.position.set(-(rw * .9 + 9.5), 0, -(rw * .35 + 4));
      bowlB.position.set(-(rw * .9 + 14.5), 0, -(rw * .35 + 13));
      brush.position.set(-(rw + 3.5), .36, rw * .45 + 5); brush.rotation.y = Math.PI - .32;
      jar.position.set(rw * .95 + 10, 0, -(rw * .5 + 10));
    };
    var moving = [head, base, bowlA, bowlB, brush, jar], fit1 = A.fit;
    A.fit = function (def, prof) {
      var from = moving.map(function (o) { return [o.position.clone(), o.scale.clone()]; });
      fit1(def, prof);
      var to = moving.map(function (o) { return [o.position.clone(), o.scale.clone()]; });
      A.blend = function (e) { moving.forEach(function (o, i) { o.position.lerpVectors(from[i][0], to[i][0], e); o.scale.lerpVectors(from[i][1], to[i][1], e); }); if (e >= 1) A.blend = null; };
      A.blend(0);
    };
    A.setColors = function (d) {
      var mot = d.motif === 'uni' ? null : vivid(hexOf(d.couleur), VIV.s, VIV.l);
      var fon = d.fond === NATURAL ? NATURAL_HEX : vivid(hexOf(d.fond), VIV.fs, VIV.fl);
      bowlA.liquid.material.color.set(mot || fon).convertSRGBToLinear();
      bowlB.liquid.material.color.set(mot ? fon : NATURAL_HEX).convertSRGBToLinear();
      bristleMat.color.set(mot || fon).convertSRGBToLinear();
    };
    /* lumière de fenêtre et ombres douces, cadrées sur la pièce */
    var key = v.key; scene.add(key.target);
    key.castShadow = true; key.shadow.mapSize.set(mob ? 1024 : 2048, mob ? 1024 : 2048);
    key.shadow.bias = -.0004; key.shadow.normalBias = .04;
    buildDecor(v, A, window.MB_DECOR);
    return A;
  }

  /* ---------- Visionneuse ---------- */
  function Viewer(el, opts) {
    this.el = el; this.opts = opts || {}; this.design = null;
    this._spin = this.opts.autoRotate !== false && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); this._ang = 0; this._vel = 0; this._drag = false;
    this.ready = loadThree().then(this._init.bind(this));
  }
  Viewer.prototype._init = function () {
    var self = this, el = this.el, o = this.opts;
    var canvas = document.createElement('canvas'); canvas.className = 'mb3d-canvas'; canvas.style.cssText = 'display:block;width:100%;height:100%;touch-action:none;outline:none';
    el.appendChild(canvas);
    var renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, preserveDrawingBuffer: !!o.snapshots });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    var atelier = o.scene === 'atelier';
    if (atelier) { renderer.shadowMap.enabled = true; renderer.shadowMap.type = THREE.PCFSoftShadowMap; }
    renderer.outputEncoding = THREE.sRGBEncoding; renderer.toneMapping = THREE.ACESFilmicToneMapping; renderer.toneMappingExposure = VIV.exp; if (VIV.tm === 'none') renderer.toneMapping = THREE.NoToneMapping;
    var scene = new THREE.Scene(); scene.background = new THREE.Color(atelier ? '#ebe1d2' : (o.background || '#ffffff'));
    var pmrem = new THREE.PMREMGenerator(renderer); scene.environment = pmrem.fromScene(new THREE.RoomEnvironment(), .04).texture;
    /* lumière dosée pour que le blanc de l'émail ne sature pas : les couleurs claires (rose clair, lilas, céladon…) restent lisibles */
    var key = new THREE.DirectionalLight(0xffffff, .6); key.position.set(6, 14, 9); scene.add(key);
    var camera = new THREE.PerspectiveCamera(atelier ? 38 : 30, 1, .1, 600);
    var controls = new THREE.OrbitControls(camera, canvas);
    controls.enableDamping = true; controls.dampingFactor = .08; controls.enablePan = false; controls.autoRotateSpeed = 1.6; controls.maxPolarAngle = Math.PI - .12;
    controls.autoRotate = !atelier && this._spin;
    /* atelier : la caméra reste face à l'établi ; c'est la tournette qui tourne */
    if (atelier) { controls.minAzimuthAngle = 0; controls.maxAzimuthAngle = 0; controls.minPolarAngle = .38; controls.maxPolarAngle = 1.5; }
    if (o.interactive === false) { controls.enableRotate = false; controls.enableZoom = false; }
    var W = o.texSize || (window.innerWidth < 760 ? 1536 : 2048);
    var tex = document.createElement('canvas'); tex.width = tex.height = W;
    var rough = document.createElement('canvas'); rough.width = rough.height = W;
    var map = new THREE.CanvasTexture(tex); map.encoding = THREE.sRGBEncoding; map.anisotropy = renderer.capabilities.getMaxAnisotropy();
    var roughMap = new THREE.CanvasTexture(rough);
    var bodyMat = new THREE.MeshPhysicalMaterial({ map: map, roughnessMap: roughMap, roughness: 1, metalness: 0, clearcoat: .4, clearcoatRoughness: .25, envMapIntensity: .8, side: THREE.DoubleSide, fog: false });
    var handleMat = new THREE.MeshPhysicalMaterial({ color: new THREE.Color(NATURAL_HEX), roughness: .33, metalness: 0, clearcoat: .38, clearcoatRoughness: .26, envMapIntensity: .8, fog: false });
    handleMat.color.convertSRGBToLinear();
    var sc = document.createElement('canvas'); sc.width = sc.height = 256; var c2 = sc.getContext('2d'); var gr = c2.createRadialGradient(128, 128, 0, 128, 128, 128);
    gr.addColorStop(0, 'rgba(35,38,67,.3)'); gr.addColorStop(.45, 'rgba(35,38,67,.11)'); gr.addColorStop(1, 'rgba(35,38,67,0)'); c2.fillStyle = gr; c2.fillRect(0, 0, 256, 256);
    var shadow = new THREE.Mesh(new THREE.PlaneGeometry(1, 1), new THREE.MeshBasicMaterial({ map: new THREE.CanvasTexture(sc), transparent: true, depthWrite: false, fog: false }));
    shadow.rotation.x = -Math.PI / 2; scene.add(shadow);
    Object.assign(this, { canvas: canvas, renderer: renderer, scene: scene, camera: camera, controls: controls, W: W, tex: tex, rough: rough, map: map, roughMap: roughMap, bodyMat: bodyMat, handleMat: handleMat, shadow: shadow, key: key, group: null, shapeKey: null });
    if (atelier) {
      this.atelier = buildAtelier(this); this._spinInput(canvas);
      /* reflets plus doux : la couleur de l'émail se lit mieux */
      bodyMat.envMapIntensity = .45; bodyMat.clearcoat = .35; bodyMat.clearcoatRoughness = .28; handleMat.envMapIntensity = .45; handleMat.clearcoat = .3; key.intensity = .52; key.color.set(0xfff3e3);
    }
    controls.addEventListener('start', function () { if (self.onInteract) self.onInteract(); });
    this._resize = function () { var w = el.clientWidth, h = el.clientHeight; if (!w || !h) return; renderer.setSize(w, h, false); camera.aspect = w / h; camera.updateProjectionMatrix(); if (self.current) self.frame(true); };
    if (window.ResizeObserver) { this._ro = new ResizeObserver(this._resize); this._ro.observe(el); } else window.addEventListener('resize', this._resize);
    this._resize();
    this._visible = true;
    if (window.IntersectionObserver) { this._io = new IntersectionObserver(function (en) { self._visible = en[0].isIntersecting; }); this._io.observe(el); }
    var last = 0;
    renderer.setAnimationLoop(function (now) {
      var dt = last ? Math.min(.05, (now - last) / 1000) : 0; last = now;
      if (!self._visible) return;
      if (self.atelier) self._turn(dt);
      if (self._camAnim) self._camAnim(now);
      controls.update(); renderer.render(scene, camera);
    });
  };
  Viewer.prototype._setShape = function (key) {
    if (this.shapeKey === key) return;
    var def = SHAPES[key];
    if (this.group) { this.group.traverse(function (o) { if (o.geometry) o.geometry.dispose(); }); this.scene.remove(this.group); }
    var g = new THREE.Group(), built = buildGeometry(key);
    g.add(new THREE.Mesh(built.geo, this.bodyMat));
    if (def.handle) g.add(new THREE.Mesh(buildHandle(def), this.handleMat));
    g.add(this._signature(def, built.prof));
    if (this.atelier) {
      /* la pièce est posée sur la tournette, présentée sous son meilleur angle */
      this.atelier.fit(def, built.prof); g.position.y = this.atelier.top;
      g.children.forEach(function (m) { if (m.geometry && m.geometry.type !== 'CircleGeometry') m.castShadow = true; });
      this._ang = -(def.kind === 'vessel' ? 1.42 : .7); this._vel = 0; g.rotation.y = this._ang; this.atelier.head.rotation.y = this._ang;
    }
    this.scene.add(g); this.group = g; this.prof = built.prof; this.shapeKey = key;
    var box = new THREE.Box3().setFromObject(g), size = box.getSize(new THREE.Vector3()), center = box.getCenter(new THREE.Vector3());
    if (this.atelier) { var fr = def.kind === 'plate' ? def.keys[def.keys.length - 2][0] : def.outer[1][0], sh0 = this.shadow.scale.x; this.shadow.scale.setScalar(fr * 2.7); this.shadow.position.set(0, this.atelier.top + .02, 0); this._shadowFrom = this._framed ? sh0 : 0; }
    else { this.shadow.scale.setScalar(Math.max(size.x, size.z) * 1.3); this.shadow.position.set(center.x, .005, center.z); }
    this.current = { center: center, radius: size.length() / 2, kind: def.kind, polar: def.viewPolar, group: def.group };
    if (this.atelier && this._framed) { g.scale.setScalar(.9); this._grow = g; }
    this.frame();
  };
  /* signature « Marobali » écrite à la main sous la pièce */
  Viewer.prototype._signature = function (def, prof) {
    if (!this._sigMat) {
      var c = document.createElement('canvas'); c.width = 1024; c.height = 1024; var x = c.getContext('2d');
      x.translate(512, 512); x.rotate(-.08);
      x.fillStyle = '#2b2f63'; x.globalAlpha = .88; x.textAlign = 'left'; x.textBaseline = 'middle';
      var txt = 'MAROBALI', fs = 150, fam = '"Segoe Print","Bradley Hand","Marker Felt","Chalkboard SE","Comic Sans MS",cursive';
      x.font = 'italic 500 ' + fs + 'px ' + fam;
      var sp = 6, tw = 0, ch, i; for (i = 0; i < txt.length; i++) tw += x.measureText(txt[i]).width + sp;
      if (tw > 880) { fs = Math.floor(fs * 880 / tw); x.font = 'italic 500 ' + fs + 'px ' + fam; tw = 0; for (i = 0; i < txt.length; i++) tw += x.measureText(txt[i]).width + sp; }
      var jr = rng(2024), cx = -tw / 2;
      for (i = 0; i < txt.length; i++) {
        ch = txt[i]; x.save(); x.translate(cx, (jr() - .5) * fs * .1); x.rotate((jr() - .5) * .09);
        x.fillText(ch, 0, 0); x.restore(); cx += x.measureText(ch).width + sp;
      }
      var t = new THREE.CanvasTexture(c); t.encoding = THREE.sRGBEncoding; t.anisotropy = 8;
      this._sigMat = new THREE.MeshStandardMaterial({ map: t, transparent: true, roughness: .45, metalness: 0, depthWrite: false, polygonOffset: true, polygonOffsetFactor: -4, polygonOffsetUnits: -4 });
    }
    var plate = def.kind === 'plate', foot = plate ? def.keys[def.keys.length - 2][0] : def.outer[1][0];
    var y0 = plate ? prof.P[prof.N - 1][1] : prof.P[0][1];
    var m = new THREE.Mesh(new THREE.CircleGeometry(foot * .82, 48), this._sigMat);
    m.rotation.x = Math.PI / 2; m.position.y = y0 - .015;
    return m;
  };
  Viewer.prototype.frame = function (instant) {
    var c = this.current; if (!c) return;
    var self = this, cam = this.camera, ctl = this.controls, fov = cam.fov * Math.PI / 180, aspect = cam.aspect || 1;
    var dist = c.radius / Math.sin(fov / 2) * (aspect < 1 ? 1.25 / Math.sqrt(aspect) : 1.25) * (this.opts.zoom || 1);
    var polar = c.polar || (c.kind === 'plate' ? .9 : (c.kind === 'open' ? 1.0 : 1.3)), azim = this.atelier ? 0 : (c.kind === 'vessel' ? 1.42 : .7);
    if (this.atelier) { polar = Math.min(1.45, polar + .05); dist *= (window.innerWidth < 760 ? .93 : 1.04) * (c.group === 'Tasses & pichets' ? 1.08 : 1); }
    var tg = new THREE.Vector3(c.center.x, c.center.y + c.radius * (c.kind === 'vessel' ? .08 : 0), c.center.z);
    var minD = dist * .45, maxD = dist * 1.9, A = this.atelier, grow = this._grow, sh0 = this._shadowFrom, sh1 = this.shadow.scale.x;
    this._grow = null; this._shadowFrom = 0;
    function place(t, d, pol) { cam.position.set(t.x + d * Math.sin(pol) * Math.sin(azim), t.y + d * Math.cos(pol), t.z + d * Math.sin(pol) * Math.cos(azim)); }
    if (A && !instant && this._framed) {
      /* atelier : la caméra glisse doucement vers la nouvelle pièce, la tournette et les accessoires suivent */
      var t0 = ctl.target.clone(), d0 = cam.position.distanceTo(t0), p0 = Math.acos(Math.max(-1, Math.min(1, (cam.position.y - t0.y) / Math.max(d0, 1e-6)))), start = 0, dur = 750;
      ctl.minDistance = Math.min(minD, d0); ctl.maxDistance = Math.max(maxD, d0);
      this._camAnim = function (now) {
        if (!start) start = now; /* le compte commence à la première image, une fois la pièce prête */
        var k = Math.min(1, Math.max(0, (now - start) / dur)), e = k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
        ctl.target.lerpVectors(t0, tg, e); place(ctl.target, d0 + (dist - d0) * e, p0 + (polar - p0) * e);
        if (A.blend) A.blend(e);
        if (grow) grow.scale.setScalar(.9 + .1 * e);
        if (sh0) self.shadow.scale.setScalar(sh0 + (sh1 - sh0) * e);
        if (k >= 1) { self._camAnim = null; ctl.minDistance = minD; ctl.maxDistance = maxD; }
      };
    } else {
      this._camAnim = null; ctl.target.copy(tg); place(tg, dist, polar); ctl.minDistance = minD; ctl.maxDistance = maxD;
      if (A && A.blend) A.blend(1);
      if (grow) grow.scale.setScalar(1);
    }
    ctl.update(); this._framed = true;
    if (A) { this._vel = 0; A.light(tg, c.radius, dist); }
  };
  Viewer.prototype.set = function (design) {
    var self = this;
    return this.ready.then(function () {
      var d = Object.assign({ clay: 'blanche', motif: 'uni', fond: NATURAL, couleur: 'Bleu nuit' }, design);
      var cl = claysFor(d.shape); if (cl.indexOf(d.clay) < 0) d.clay = cl[0];
      self._setShape(shapeKeyFor(d));
      paint(self.prof, d, self.tex.getContext('2d'), self.rough.getContext('2d'), self.W);
      self.map.needsUpdate = true; self.roughMap.needsUpdate = true;
      if (self.atelier) self.atelier.setColors(d);
      self.handleMat.color.set(d.fond === NATURAL ? NATURAL_HEX : vivid(hexOf(d.fond), VIV.fs, VIV.fl)).convertSRGBToLinear();
      self.design = d;
    });
  };
  Viewer.prototype.setAutoRotate = function (on) { this._spin = !!on; if (this.controls && !this.atelier) this.controls.autoRotate = !!on; };
  /* atelier : la tournette tourne seule (même vitesse que la rotation des fiches), on la lance du doigt, elle ralentit doucement */
  Viewer.prototype._turn = function (dt) {
    if (this._spin && !this._drag) this._ang += dt * .1676;
    if (!this._drag && this._vel) { this._ang += this._vel * dt; this._vel *= Math.exp(-dt * 3); if (Math.abs(this._vel) < .01) this._vel = 0; }
    if (this.group) this.group.rotation.y = this._ang;
    this.atelier.head.rotation.y = this._ang;
  };
  Viewer.prototype._spinInput = function (canvas) {
    var self = this, act = {}, lastX = 0, lastT = 0;
    function count() { return Object.keys(act).length; }
    canvas.addEventListener('pointerdown', function (e) { act[e.pointerId] = 1; if (count() === 1) { self._drag = true; self._vel = 0; lastX = e.clientX; lastT = e.timeStamp; } else self._drag = false; });
    canvas.addEventListener('pointermove', function (e) {
      if (!self._drag || !act[e.pointerId]) return;
      var d = TAU * (e.clientX - lastX) / Math.max(1, canvas.clientHeight), dt = Math.max(8, e.timeStamp - lastT) / 1000;
      self._ang += d; self._vel = Math.max(-12, Math.min(12, .7 * d / dt + .3 * self._vel)); lastX = e.clientX; lastT = e.timeStamp;
    });
    function up(e) { if (!act[e.pointerId]) return; delete act[e.pointerId]; if (!count()) { if (e.timeStamp - lastT > 90) self._vel = 0; self._drag = false; } }
    canvas.addEventListener('pointerup', up); canvas.addEventListener('pointercancel', up);
  };
  Viewer.prototype.snapshot = function (size) {
    var r = this.renderer; if (!r) return '';
    this.controls.update(); r.render(this.scene, this.camera);
    var src = r.domElement; size = size || 240;
    var c = document.createElement('canvas'); c.width = c.height = size; var x = c.getContext('2d');
    x.fillStyle = '#ffffff'; x.fillRect(0, 0, size, size);
    var s = Math.min(src.width, src.height); x.drawImage(src, (src.width - s) / 2, (src.height - s) / 2, s, s, 0, 0, size, size);
    try { return c.toDataURL('image/jpeg', .82); } catch (e) { return ''; }
  };
  Viewer.prototype.dispose = function () {
    if (this._ro) this._ro.disconnect(); if (this._io) this._io.disconnect();
    if (this.renderer) { this.renderer.setAnimationLoop(null); this.renderer.dispose(); }
    if (this.canvas && this.canvas.parentNode) this.canvas.parentNode.removeChild(this.canvas);
  };

  window.MarobaliAtelier = { SHAPES: SHAPES, MOTIFS: MOTIFS, PALETTE: PALETTE, CLAYS: CLAYS, NATURAL: NATURAL, hexOf: hexOf, fromProduct: fromProduct, motifsFor: motifsFor, shapeKeyFor: shapeKeyFor, dipMode: dipMode, claysFor: claysFor, Viewer: Viewer, load: loadThree, _profile: buildProfile };
})();
